<template>
  <div>
    <template v-if="recommendContentType || totalCount === 0">
      <div v-if="!isLoading" >
        <SearchEmptyMessage
          :search-title="searchWord"
          :total-count="totalCount"
          :is-loading="isLoading"
          :recommend-content-type="recommendContentType"
          :change-word="changeWord"
        />
      </div>
    </template>
    <template v-else>
      <template v-if="category === 'theme'">
        <div>
          <template v-for="(sectionInfo, index) in multiSectionList">
            <DynamicSectionLoader
              :section-info="sectionInfo"
              :key="`${sectionInfo.title}${$route.name}${index}`"
            />
          </template>
        </div>
        <div ref="scrollMonitor"></div>
      </template>
      <template v-else>
        <template v-for="(sectionInfo, index) in multiSectionList">
          <DynamicSectionLoader
            :section-info="sectionInfo"
            :key="`${sectionInfo.title}${$route.name}${index}`"
          />
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import DynamicSectionLoader from '@/components/container/DynamicSectionLoader'
import { getSearchMultiSection } from '@/common/utils/request'
import { onDisplay } from '@/common/resources/directives'
import { setDisableScrolling } from '@/common/utils/common'
import { setTransactionKeyToStorage } from '@/common/utils/storage.util'
import SearchEmptyMessage from '@/components/search/view/SearchEmptyMessage'
import scrollMonitor from 'scrollmonitor'

export default {
  name: 'SearchKeywordMultiBand',
  components: {
    DynamicSectionLoader,
    SearchEmptyMessage
  },
  props: {
    searchWord: {
      type: String
    },
    category: {
      type: String
    }
  },
  directives: {
    onDisplay
  },
  data () {
    return {
      isLoading: true,
      limit: 5,
      offset: 0,
      multiSectionList: [],
      changeWord: '',
      endOfList: false,
      recommendContentType: ''
    }
  },
  methods: {
    setData () {
      this.isLoading = true
      getSearchMultiSection({
        offset: this.offset,
        limit: this.limit,
        orderby: 'score',
        type: this.category,
        keyword: this.searchWord,
        mtype: this.mtype || 'all',
        version: 2
      }).then(({ data }) => {
        this.bandCount = Number(_.get(data, 'totalcount', '0'))
        const multiSectionListFromRemote = _.get(data, 'multisectionlist', []).filter((multiSection) => multiSection.title !== 'TV컷')
        this.multiSectionList = [...this.multiSectionList, ...multiSectionListFromRemote]
        this.changeWord = _.get(data, 'changekeyword', '')
        if (multiSectionListFromRemote.length === 0) { this.endOfList = true }
        this.recommendContentType = _.get(data, 'recommendviewtype', '')
        setTransactionKeyToStorage(data)
        this.isLoading = false
      })
    },
    loadMore: _.throttle(function () {
      if (this.endOfList) return
      this.offset += this.limit
      this.setData()
    }, 120)
  },
  computed: {
    totalCount () {
      const cellCount = this.multiSectionList.reduce((acc, curr) => acc + Number(_.get(curr, 'count', '0')), 0)
      return Math.max(cellCount, this.bandCount)
    }
  },
  created () {
    setDisableScrolling(false)
    this.setData()
  },
  mounted () {
    if (this.category === 'theme') {
      const monitorEl = this.$refs['scrollMonitor']
      const watcher = scrollMonitor.create(monitorEl, 300)
      watcher.enterViewport(this.loadMore)
    }
  }
}
</script>
